import { getRequest } from '@/core';
import { trips } from '@/requests';

export default async function getTripOrdersRequest(id) {
	let url = trips.getTripOrdersPath(id);
	let response = await getRequest(url);
	return response;
}
